import mainApi, { LL_PERIODS } from './mainApi'

const endpoints = mainApi.injectEndpoints({
    endpoints: (builder) => ({
        getPeriods: builder.query<{ eligible: boolean; earliest_end_date: Date }, string>({
            query: () => ({
                url: `/earliest-period-end-calculations`,
                method: 'POST',
            }),
            providesTags: (result, error, arg) => [LL_PERIODS],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPeriodsQuery } = endpoints
